import { Observable, timer } from 'rxjs';
import { map, take } from 'rxjs/operators';

export class Timer {
  public TIMEOUT_SECONDS = 60;

  private localStorageKey: string;

  constructor(storageKey: string) {
    this.localStorageKey = storageKey;
  }

  public remove(): void {
    localStorage.removeItem(this.localStorageKey);
  }

  public initTimer(): Observable<number> {
    let secondsLeft = this.findSecondsLeft();
    if (secondsLeft < 0) {
      secondsLeft = 0;
    }

    return timer(0, 1000).pipe(
      map((i) => secondsLeft - i),
      take(secondsLeft + 1),
    );
  }

  private findSecondsLeft(): number {
    const storageTime = localStorage.getItem(this.localStorageKey);
    let secondsLeft = this.TIMEOUT_SECONDS;

    const now = new Date().getTime();

    if (storageTime) {
      const startedAt = parseInt(storageTime, 10);
      const diffInSeconds = Math.round((now - startedAt) / 1000);

      secondsLeft = this.TIMEOUT_SECONDS - diffInSeconds;
    }

    if (secondsLeft === this.TIMEOUT_SECONDS) {
      localStorage.setItem(this.localStorageKey, new Date().getTime().toString());
    }

    return secondsLeft;
  }
}
